const FormFieldText = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  errorMessage,
  className = "",
  ...props
}) => {
  return (
    <div className={`input-container ${className}`}>
      <label htmlFor={name}>{label}</label>
      <input
        placeholder={placeholder}
        id={name}
        name={name}
        type={props.type || "text"}
        value={value}
        onChange={(e) => onChange(e)}
        {...props}
      />
      <div className="error-msg">{errorMessage}</div>
    </div>
  );
};

export default FormFieldText;
